export const isBoolean = (value) => typeof value === 'boolean'

export const isFunction = (value) => typeof value === 'function'

export const isNumber = (value) => typeof value === 'number'

export const isString = (value) => typeof value === 'string'

export const isArray = (value) => Array.isArray(value)

export const isObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value)

export const isPromise = (value) => isObject(value) && isFunction(value.then)

export const isDate = (value) => value instanceof Date

export const isJson = (value) => {
  if (!isString(value) || isEmpty(value)) return false
  try {
    JSON.parse(value)
  } catch (e) {
    return false
  }
  return true
}

export function isEmpty(value) {
  let empty = false
  if (value === null || value === undefined) empty = true
  else if (isString(value) && value === '') empty = true
  else if ((isArray(value) || isString(value)) && value.length < 1) empty = true
  else if (isString(value) && !/\S/.test(value)) empty = true
  else if (isObject(value) && Object.keys(value).length < 1) empty = true
  return empty
}

export function isNotEmpty(value) {
  return !isEmpty(value)
}
